/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Image_DescriptionInputs */



/**
* | output |
* | --- |
* | "Run compliance checks on image generation and editing prompts." |
*
* @param {Compliance_Image_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_image_description = /** @type {((inputs?: Compliance_Image_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Image_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance-Prüfungen für Bildgenerierungs- und Bearbeitungsanfragen durchführen.")
	return /** @type {LocalizedString} */ ("Run compliance checks on image generation and editing prompts.")
});